import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import EditorPageHeader, { StickyEditorPageHeaderWrapper } from 'components/EditorPageHeader';
import FixedHeightTab from 'components/Tab/FixedHeightTab';
import Icon from 'components/Icon';
import AssetHeaderSubtitle from './AssetHeaderSubtitle';
import AssetHeaderOptionsMenu from './AssetHeaderOptionsMenu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SingleAssetHeader(_ref) {
  var hasOpenOption = _ref.hasOpenOption,
    titleId = _ref.titleId,
    parentPlaylistId = _ref.parentPlaylistId,
    asset = _ref.asset,
    shareData = _ref.shareData,
    tabLinks = _ref.tabLinks,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var assetId = asset.id;
  var isAssetAdmin = hasPrivilege(ASSET_WRITE);
  return /*#__PURE__*/_jsx(StickyEditorPageHeaderWrapper, {
    children: /*#__PURE__*/_jsxs(EditorPageHeader, {
      title: asset.name,
      titleId: titleId,
      navMenu: /*#__PURE__*/_jsx(AssetHeaderOptionsMenu, {
        hasOpenOption: hasOpenOption,
        asset: asset,
        parentPlaylistId: parentPlaylistId,
        shareData: shareData
      }),
      subtitle: /*#__PURE__*/_jsx(AssetHeaderSubtitle, {
        asset: asset
      }),
      onClose: onClose,
      cardVariant: "raised",
      children: [/*#__PURE__*/_jsxs(FixedHeightTab, {
        isActive: tabLinks.details.isActive,
        as: Link,
        to: generatePath(tabLinks.details.link, {
          assetId: assetId
        }),
        "aria-current": tabLinks.details.isActive ? 'page' : undefined,
        isDisabled: asset === undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "asset-image",
          mr: "xs"
        }), t('panel_tab_details')]
      }), isAssetAdmin && /*#__PURE__*/_jsxs(FixedHeightTab, {
        isActive: tabLinks.share.isActive,
        as: Link,
        to: generatePath(tabLinks.share.link, {
          assetId: assetId
        }),
        "aria-current": tabLinks.share.isActive ? 'page' : undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "send",
          mr: "xs"
        }), t('panel_tab_share_and_nudge')]
      }), isAssetAdmin && /*#__PURE__*/_jsxs(FixedHeightTab, {
        isActive: tabLinks.analytics.isActive,
        as: Link,
        to: generatePath(tabLinks.analytics.link, {
          assetId: assetId
        }),
        "aria-current": tabLinks.analytics.isActive ? 'page' : undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "trending",
          mr: "xs"
        }), t('panel_tab_analytics')]
      })]
    })
  });
}
export default SingleAssetHeader;